import axiosInstance from './axiosConfig';

const bannerService = {
  // Get all orders with pagination and filters
  getBanners: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/banner', { params });
      return response;
    } catch (error) {
      throw error;
    }
  },
  // Create new product
  createBanner: async (productData) => {
    try {
      const response = await axiosInstance.post('/banner', productData,
        {
           headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update product
  updateBanner: async (id, productData) => {
    try {
      const response = await axiosInstance.put(`/banner/${id}`, productData,
         {
           headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Delete product
  deleteBanner: async (id) => {
    try {
      const response = await axiosInstance.delete(`/banner/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },
}

export default bannerService;